import { DocumentType } from '@app/api/types';
const LEGAL_URLS = {
    termsOfUse: {
        lt: 'https://www.paysera.lt/v2/lt-LT/legal/platformos-naudojimo-taisykles',
        en: 'https://www.paysera.lt/v2/en-LT/legal/rules-for-the-use-of-the-platform',
    },
    creditworthinessRules: {
        lt: 'https://www.paysera.lt/v2/lt-LT/legal/creditworthiness-assessment-rules',
        en: 'https://www.paysera.lt/v2/en-LT/legal/creditworthiness-assessment-rules',
    },
    consentBorrower: {
        lt: 'https://www.paysera.lt/v2/lt-LT/legal/sutikimas-del-asmens-duomenu-tvarkymo-borrower',
        en: 'https://www.paysera.lt/v2/en-LT/legal/consumer-credit-recipient-consent-for-personal-data-processing',
    },
    consentInvestor: {
        lt: 'https://www.paysera.lt/v2/lt-LT/legal/sutikimas-del-asmens-duomenu-tvarkymo-investor',
        en: 'https://www.paysera.lt/v2/en-LT/legal/consumer-credit-provider-consent-for-personal-data-processing',
    },
    debtRecovery: {
        lt: 'https://www.paysera.lt/v2/lt-LT/legal/skolu-isieskojimo-procedura',
        en: 'https://www.paysera.lt/v2/en-LT/legal/debt-recovery-procedure',
    },
    conflictOfInterest: {
        lt: 'https://www.paysera.lt/v2/lt-LT/legal/Interesu-konfliktu-sprendimo-politika',
        en: 'https://www.paysera.lt/v2/en-LT/legal/conflict-of-interest-management-policy',
    },
    generalConditions: {
        lt: 'https://www.paysera.lt/v2/lt-LT/legal/vartojimo-kredito-sutartis-bendrosios-salygos',
        en: 'https://www.paysera.lt/v2/lt-LT/legal/vartojimo-kredito-sutartis-bendrosios-salygos',
    },
    serviceFee: {
        lt: 'https://www.paysera.lt/v2/lt-LT/legal/tarpusavio-skolinimo-platformos-naudotojams-taikomi-ikain-ai-uz-paslaugas',
        en: 'https://www.paysera.lt/v2/lt-LT/legal/tarpusavio-skolinimo-platformos-naudotojams-taikomi-ikain-ai-uz-paslaugas',
    },
    privacyPolicy: {
        lt: 'https://www.paysera.lt/v2/lt-LT/sutartys/privatumo-politika',
        en: 'https://www.paysera.lt/v2/lt-LT/sutartys/privatumo-politika',
    },
    businessContinuity: {
        lt: 'https://www.paysera.lt/v2/lt-LT/legal/veiklos-testinumo-planas',
        en: 'https://www.paysera.lt/v2/lt-LT/legal/veiklos-testinumo-planas',
    },
};
export const getLegalUrl = (key, locale) => LEGAL_URLS[key][locale];
export const getDocumentsBorrower = (locale) => [
    {
        name: 'financing.loan_details.documents.general_conditions',
        url: getLegalUrl('generalConditions', locale),
    },
    {
        name: 'financing.loan_details.documents.rules_for_assessing_creditworthiness',
        url: getLegalUrl('creditworthinessRules', locale),
    },
    {
        name: 'financing.loan_details.documents.service_fee',
        url: getLegalUrl('serviceFee', locale),
    },
    {
        name: 'financing.loan_details.documents.terms_of_use',
        url: getLegalUrl('termsOfUse', locale),
    },
    {
        name: 'financing.loan_details.documents.consent_to_processing',
        url: getLegalUrl('consentBorrower', locale),
    },
    {
        name: 'financing.loan_details.documents.privacy_policy',
        url: getLegalUrl('privacyPolicy', locale),
    },
];
export const getDocumentsInvestor = (locale) => [
    {
        name: 'financing.loan_details.documents.service_fee',
        url: getLegalUrl('serviceFee', locale),
    },
    {
        name: 'financing.loan_details.documents.rules_for_assessing_creditworthiness',
        url: getLegalUrl('creditworthinessRules', locale),
    },
    {
        name: 'financing.loan_details.documents.consent_to_processing',
        url: getLegalUrl('consentInvestor', locale),
    },
    {
        name: 'financing.loan_details.documents.debt_collection_process',
        url: getLegalUrl('debtRecovery', locale),
    },
    {
        name: 'financing.loan_details.documents.business_continuity_plan',
        url: getLegalUrl('businessContinuity', locale),
    },
    {
        name: 'financing.loan_details.documents.general_conditions',
        url: getLegalUrl('generalConditions', locale),
    },
    {
        name: 'financing.loan_details.documents.terms_of_use',
        url: getLegalUrl('termsOfUse', locale),
    },
    {
        name: 'financing.loan_details.documents.privacy_policy',
        url: getLegalUrl('privacyPolicy', locale),
    },
];
export const customDocumentsList = {
    investor: [
        {
            name: 'financing.loan_details.documents.special_conditions',
            type: DocumentType.InvestmentSpecialConditions,
        },
        {
            name: 'financing.loan_details.documents.loan_schedule',
            type: DocumentType.InvestmentLoanSchedule,
        },
    ],
    borrower: [
        {
            name: 'financing.loan_details.documents.loan_schedule',
            type: DocumentType.LoanSchedule,
        },
        {
            name: 'financing.loan_details.documents.special_conditions',
            type: DocumentType.LoanSpecialConditions,
        },
    ],
};
